import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    items: null,
    grupos: null,
    gruposNovaOs: null,
  },

  getters: {
    items: (state) => state.items,
    grupos: (state) => state.grupos,
    gruposNovaOs: (state) => state.gruposNovaOs
  },

  actions: {
    async fetchFromApi ({ commit }) {
      try {
        const response = await api.get('frota/conjuntos')
        
        commit('setItems', response.data.items)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    
    async getGrupos ({ commit }) {
      try {
        const response = await api.get(`frota/gruposFiltro`)
        
        commit('setGrupos', response.data.grupos)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async getGruposNovaOs ({ commit }, { operacao }) {
      try {
        const response = await api.get(`frota/grupos/${operacao}`)
        
        commit('setGruposNovaOs', response.data.grupos)
        return response
      } catch (error) {
        throw new Error(error)
      }
    }
  },

  mutations: {
    setItems (state, items) {
      state.items = items
    },
    setGrupos (state, grupos) {
      state.grupos = grupos
    },
    setGruposNovaOs (state, grupos) {
      state.gruposNovaOs = grupos
    }
  }
}
